// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__204aR","signatureBlock":"Footer_signatureBlock__1CLWc","signature":"Footer_signature__jwYHp"};